<template>
  <div>
    <NavBar/>
    <div id="iBody" :class="addClass">
      <router-view/>
      <Footer/>
    </div>
    <div class="mainCover"></div>
    <div class="mainBg">
      <ul id="cbp-bislideshow" class="bgSlideShow cbp-bislideshow">
        <li v-for="(bg, i) in bgs" :key="bg" :style="'background-image: url(' + bg.img + ')'" :class="{ active: active === i }"></li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss">
@import "./assets/scss/all";
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400&family=Oswald:wght@400;700&display=swap');
.bgSlideShow {
}
.bgSlideShow li {
  opacity: 0;
  background-size: cover;
}
.bgSlideShow li.active {
  opacity: 1;
}
</style>

<script>
import emitter from '@/methods/mitt' // mitt.js
import NavBar from '@/components/NavBar.vue'
import Footer from '@/components/Footer.vue'
// import Modder from '@/assets/data.json'
// import Modder from '../public/data.json' // 用這種方法會被打包，上線後無法直接修改data.json檔去更新
export default {
  data () {
    return {
      id: {},
      active: 0,
      bgs: [
        {
          img: `${require('@/assets/images/bg_img_1.jpg')}`
        },
        {
          img: `${require('@/assets/images/bg_img_2.jpg')}`
        }
      ],
    }
  },
  components: {
    NavBar,
    Footer
  },
  methods: {
    
  },
  provide () { // mitt套件
    return {
      emitter
    }
  },
  computed: {
    addClass () {
      return {
        gBody: this.$route.path !== '/'
      }
    }
  },
  // watch:{ // 偵聽$route變動，就判斷是否為首頁，加或拿掉class
  //   $route(to, from) {
  //     console.log('path', this.$route.path)
  //     if(this.$route.path !== "/") {
  //       // this.$refs.homeCont.setAttribute("class", "animated printbox animated_mar");
  //       // function linkHeight(addClass) {
  //       //   console.log("A")
  //       //   //抓取高度
  //       //   this.linkIdDistance = linkId.offsetTop;
  //       //   addClass()
  //       // }
  //       // function addClass() {
  //       //   console.log("B")
  //       //   this.$refs.homeCont.$el.classList.value = 'hideHomeCont';
  //       // }
  //       // linkHeight(addClass)
  //       this.$refs.homeCont.$el.classList.value = 'hideHomeCont';

  //     } else {
  //       this.$refs.homeCont.$el.classList.value = ''
  //     }
  //   }
  // },
  created () { // 重要!!!!!!!!!!!：要經常性變動的東西可以放在 public 下，用./引入，ModderView.vue裡的圖片也一樣
    setInterval(() => {
      if (this.active < this.bgs.length - 1) { // 背景自動輪播
        this.active++
      } else {
        this.active = 0
      }
    }, 10000)
    // this.id = this.$route.params.lang;
    // console.log('App', this.$route.path, this.id)
  },
  mounted () {
    this.id = this.$route.params.lang;
    console.log('App', this.$route.path, this.id)
  }
}
</script>
